"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const ApiClient_1 = require("../lib/ApiClient");
var LivechatSubjectType;
(function (LivechatSubjectType) {
    LivechatSubjectType["PUBLIC_LIVECHAT"] = "public_livechat";
    LivechatSubjectType["APPOINTMENT"] = "appointment";
})(LivechatSubjectType = exports.LivechatSubjectType || (exports.LivechatSubjectType = {}));
var LiveChatUserUpdateAction;
(function (LiveChatUserUpdateAction) {
    LiveChatUserUpdateAction["UPDATE"] = "UPDATE";
    LiveChatUserUpdateAction["DELETE"] = "DELETE";
})(LiveChatUserUpdateAction = exports.LiveChatUserUpdateAction || (exports.LiveChatUserUpdateAction = {}));
exports.isPublicLiveChatNotificationDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "PublicLiveChatNotificationDetails";
};
class LivechatsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            LiveChatJoinResponse: () => `
        ... on LiveChatJoinResponse {
          me {
            ${this.getFragment("LiveChatUser")}
          }
          users {
            ${this.getFragment("LiveChatUser")}
          }
          token
          serverTime
          threadId
        }
      `,
            LiveChatUser: () => `
        ... on LiveChatUser {
          id
          chatId
          userId
          user {
            ${this.getFragment("UserPublicData", [
                "id",
                "role",
                "screenName",
                { avatar: ["urlPart"] },
            ])}          
          }
          broadcasting
          broadcastingTime
          joinTime
          lastOnline
        }
      `,
            LiveChatUserUpdateEvent: () => `
        ... on LiveChatUserUpdateEvent {
          action
          user {
            ${this.getFragment("LiveChatUser")}
          }
        }
      `,
            LiveChatUserBroadcastingEvent: () => `
        ... on LiveChatUserBroadcastingEvent {
          chatUserId
          chatId
          broadcasting
        }
      `,
            NotificationDetails: () => `
        ... on PublicLiveChatNotificationDetails {
          empty
        }
      `,
            LivechatAccessibility: () => `
        subject {
          ${this.getFragment("Subject")}
        }
        contentSubscriptionLevel {
          ${this.getFragment("ContentSubscriptionLevel")}
        }
      `,
        };
    }
    join({ subject, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("livechatJoin", { subject }, this.getFragment("LiveChatJoinResponse"));
        });
    }
    broadcast({ token }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("livechatBroadcast", { token }, this.getFragment("WebRTCConnection"));
        });
    }
    watch({ broadcasterChatUserId, token, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("livechatWatch", { broadcasterChatUserId, token }, this.getFragment("WebRTCConnection"));
        });
    }
    keepalive({ token }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.mutate("livechatKeepalive", { token });
        });
    }
    end({ token }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.mutate("livechatEnd", { token });
        });
    }
    accessibilityFind({ subject, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("liveChatAccessibilityFind", { subject }, this.getFragment("LivechatAccessibility"));
        });
    }
    subscribeUserUpdate(token, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription($token: String!) {
          livechatUserUpdated(token: $token) {
            ${this.getFragment("LiveChatUserUpdateEvent")}
          }
        }
      `,
            variables: { token },
        }, data => {
            onData(data.livechatUserUpdated);
        }, onError);
    }
    subscribeUserBroadcasting(token, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription($token: String!) {
          livechatUserBroadcasting(token: $token) {
            ${this.getFragment("LiveChatUserBroadcastingEvent")}
          }
        }
      `,
            variables: { token },
        }, data => {
            onData(data.livechatUserBroadcasting);
        }, onError);
    }
    subscribeMessageReceived(token, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
      subscription($token: String!) {
        livechatMessageReceived(token: $token) {
          ... on Message {
            id
            senderId
            senderUser {
              ${this.getFragment("UserPublicData")}
            }
            text
            details
            threadId
            time
            attachment {
              ${this.getFragment("MessageAttachment")}
            }
          }
        }
      }
      `,
            variables: { token },
        }, data => {
            onData(data.livechatMessageReceived);
        }, onError);
    }
    subscribeAccessibilityUpdated({ subject }, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
        subscription($subject: InputSubject!) {
          livechatAccessibilityUpdated(subject: $subject) {
            ${this.getFragment("LivechatAccessibility")}
          }
        }
      `,
            variables: { subject },
        }, data => onData(data.livechatAccessibilityUpdated), onError);
    }
}
exports.LivechatsProvider = LivechatsProvider;
//# sourceMappingURL=LivechatsProvider.js.map